export default {
  namespace: "cardList",
  state: [],
  reducers: {
    storage(state, { payload }) {
      return [...payload];
    },
  },
};
